import { Canvas } from 'canvas';
import { Photo } from 'ff-canvas';
import { applyCpuFilter } from './applyCpuFilter';
import { applyGpuFilter } from './applyGpuFilter';

export const getFilterBackend = (createCanvas: () => HTMLCanvasElement | Canvas) => ({

    hashFilters: (p: Photo) => p.filter || 'none',

    applyFilters: async (
        source: HTMLImageElement | HTMLCanvasElement,
        photo: Photo,
        getDestination: () => HTMLCanvasElement
    ): Promise<HTMLImageElement | HTMLCanvasElement> => {

        if (!photo.filter || photo.filter === 'none') {
            return Promise.resolve(source);
        }

        const destination = getDestination();
        const destinationContext = destination.getContext('2d')!;
        destinationContext.drawImage(source, 0, 0, source.width, source.height);

        const webGLContext = getWebGLRenderingContext(destination, createCanvas);
        if (webGLContext) {
            applyGpuFilter(
                source, destinationContext, webGLContext,
                destination.width, destination.height,
                photo.filter);
        } else {
            applyCpuFilter(
                source, destinationContext,
                destination.width, destination.height,
                photo.filter);
        }

        return Promise.resolve(destination);
    }
});

const getWebGLRenderingContext = (
    destination: HTMLCanvasElement,
    createCanvas: () => HTMLCanvasElement | Canvas
): WebGLRenderingContext | null => {

    const canvas = createCanvas();
    canvas.width = destination.width;
    canvas.height = destination.height;

    return (canvas as HTMLCanvasElement).getContext('webgl');
};